(function () {
  // Selector de ciudad y envio del carrito (drawer). Reemplaza a
  // globalCitiesCooperadora.js: ese script dependia de un servicio de un
  // proveedor externo (pso-riteapps.com) que dejo de responder por un
  // certificado SSL vencido, y ademas tenia un error propio (hacia
  // referencia a un elemento "alertSelectCity" que no existe en el tema,
  // lo que rompia el boton "Seleccionar" incluso cuando el servicio
  // externo funcionaba).
  //
  // Este script no depende de ningun servicio externo: usa directamente las
  // tarifas de envio configuradas en Shopify (Ajustes > Envio y entrega).
  // Si Amelia cambia una tarifa alli, hay que actualizar el mismo valor en
  // la lista CIUDADES de aqui abajo para que el selector siga mostrando el
  // precio correcto.
  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.href.indexOf('/cart') !== -1) { return; }

    var alertCity = document.getElementById('alertCityDrawer');
    var setCityBtn = document.getElementById('setCityBtnDrawer');
    var selectCities = document.getElementById('coordinadoraCitiesDrawer');
    var citiesContainer = document.getElementById('citiesContainerDrawer');

    // Si el carrito de esta pagina no usa el selector de ciudad (por ejemplo
    // si el tema cambia a otro tipo de carrito en el futuro), no hacemos nada.
    if (!alertCity || !setCityBtn || !selectCities || !citiesContainer) { return; }

    var goCheckoutBtn;

    // Tarifas reales configuradas en Shopify (perfil de envio "Perfil
    // general", zona "Colombia"). Actualizar aqui si cambian en Shopify.
    var CIUDADES = [
      { name: 'Medellín', price: 15000 },
      { name: 'Bogotá', price: 30000 },
      { name: 'Cali', price: 30000 },
      { name: 'Pereira', price: 30000 },
      { name: 'Cartagena', price: 30000 },
      { name: 'Barranquilla', price: 30000 },
      { name: 'Manizales', price: 30000 },
      { name: 'Cúcuta', price: 40000 },
      { name: 'Pasto', price: 40000 },
      { name: 'Popayán', price: 40000 },
      { name: 'Otras ciudades', price: 30000 }
    ];

    function formatPrice(value) {
      return '$' + value.toLocaleString('es-CO');
    }

    citiesContainer.style.display = 'flex';
    selectCities.innerHTML = CIUDADES.map(function (c) {
      return '<option value="' + c.name + '" price="' + c.price + '" city="' + c.name + '">' +
        c.name + ' - ' + formatPrice(c.price) + '</option>';
    }).join('');

    setCityBtn.addEventListener('click', function (evt) {
      evt.preventDefault();
      var state = evt.target.getAttribute('state');
      var goCheckoutTheme = document.querySelector('button[name="checkout"]');
      if (!goCheckoutTheme) { return; }

      if (goCheckoutBtn) {
        goCheckoutBtn.style.display = 'block';
      } else {
        goCheckoutTheme.insertAdjacentHTML('beforebegin', '<a href="#" id="goToCheckout" class="btn btn--full">Cargando...</a>');
      }
      goCheckoutBtn = document.getElementById('goToCheckout');
      alertCity.textContent = '';

      if (state === 'set') {
        var optionSelected = selectCities.selectedOptions[0];
        var optionJson = {
          city: optionSelected.getAttribute('city'),
          price: optionSelected.getAttribute('price')
        };

        localStorage.setItem('coordinadoraCityData', JSON.stringify(optionJson));
        selectCities.disabled = true;
        evt.target.setAttribute('state', 'change');
        evt.target.textContent = 'Cambiar';

        setGoCheckoutUrl(optionJson, goCheckoutTheme);
      }

      if (state === 'change') {
        selectCities.disabled = false;
        evt.target.setAttribute('state', 'set');
        evt.target.textContent = 'Seleccionar';

        goCheckoutBtn.textContent = 'Seleccione Ciudad';
        goCheckoutBtn.setAttribute('href', '#');
        goCheckoutBtn.style.display = 'none';
        alertCity.textContent = 'Elige tu ciudad para continuar.';
      }
    });

    document.addEventListener('click', function (evt) {
      if (evt.target && evt.target.id === 'goToCheckout') {
        evt.preventDefault();
        evt.stopPropagation();
        if (evt.target.getAttribute('href') === '#') {
          alertCity.textContent = 'Elige tu ciudad para continuar.';
        } else {
          var checkoutBtn = document.querySelector('button[name="checkout"]');
          if (checkoutBtn) { checkoutBtn.click(); }
        }
      }
    });

    function setGoCheckoutUrl(optionJson) {
      goCheckoutBtn.textContent = 'Cargando...';

      var checkoutBtn = document.querySelector('button[name="checkout"]');
      var form = checkoutBtn ? checkoutBtn.closest('form') : null;
      if (form) {
        form.setAttribute('action', '/cart?checkout[shipping_address][city]=' + encodeURIComponent(optionJson.city));
      }

      goCheckoutBtn.setAttribute('href', 'ready');
      goCheckoutBtn.textContent = 'Finalizar Pedido';
    }
  });
})();
